import React from "react";

import { About, Achievements, Blog, Main, Prices, Services } from "./pages";
import "./App.css";
import ScrollHandler from "./ScrollHandler";

export default function Home() {
    return (
        <div className="mainBlock">
            <ScrollHandler />
            <section id="main"><Main /></section>
            <section id="services"><Services /></section>
            <section id="prices"><Prices /></section>
            <section id="aboutus"><About /></section>
            <section id="achievements"><Achievements /></section>
            <section id="faq"><Blog /></section>
        </div>
    );
}